
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AdministratorPlayersProfileTipsListFormRemove} from "@/models/app/administrator/players/profile/tips/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "tip",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AdministratorPlayersProfileTipsListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  tip: AdministratorPlayersProfileTipsListFormRemove = new AdministratorPlayersProfileTipsListFormRemove();

  formData: AdministratorPlayersProfileTipsListFormRemove = new AdministratorPlayersProfileTipsListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/tips/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getTips');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.tip;
  }

  resetFormData(): void {
    this.formData = new AdministratorPlayersProfileTipsListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
